import type { ReactNode } from 'react';
import { Text, makeStyles, tokens } from '@fluentui/react-components';
import { PageTitle } from './PageTitle';

const useStyles = makeStyles({
  root:    { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: tokens.spacingHorizontalM, flexWrap: 'wrap' },
  text:    { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalXXS, minWidth: 0 },
  actions: { display: 'flex', alignItems: 'center', gap: tokens.spacingHorizontalS, flexWrap: 'wrap' },
});

/** Encabezado estándar de página: título (h1), subtítulo opcional y acciones a la derecha. */
export function PageHeader({ title, subtitle, actions }: { title: ReactNode; subtitle?: ReactNode; actions?: ReactNode }) {
  const s = useStyles();
  return (
    <div className={s.root}>
      <div className={s.text}>
        <PageTitle>{title}</PageTitle>
        {subtitle ? <Text size={300} style={{ color: tokens.colorNeutralForeground3 }}>{subtitle}</Text> : null}
      </div>
      {actions ? <div className={s.actions}>{actions}</div> : null}
    </div>
  );
}
